export default __webpack_public_path__ + "static/media/i094vk.40cdd900.webp";